const DeleteResultWith = {
  MediaRelation: 'DeleteRelationToFSMedia',
  MediaRecord: 'DeleteFSMedia',
  MediaFile: 'DeleteRelatedS3Media',
  PRC: 'DeleteRelatedPRC',
};
export default DeleteResultWith;
